import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { DialogModule } from './dialog';
import { TimePickerModule } from './time-picker';
import { TimepickerDirective } from './timepicker/timepicker.directive';
import { TimepickerComponent } from './timepicker/timepicker.component';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { SharedPipeModule } from './pipes';
import { AppSwitcherComponent } from './app-switcher/app-switcher.component';
import { AppSwitcherDialogComponent } from './app-switcher/app-switcher-dialog/app-switcher-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [TimepickerComponent, TimepickerDirective, AppSwitcherComponent, AppSwitcherDialogComponent],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule
  ],
  entryComponents: [],
  exports: [
    FuseSharedModule,
    DialogModule,
    TimePickerModule,
    AppSwitcherComponent,
    AppSwitcherDialogComponent,
    TimepickerDirective,
    TimepickerComponent,
    SharedPipeModule
  ],
  providers: [
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
    },
  ]
})
export class ArtstuffSharedModule {
  constructor(private _translateService: TranslateService, private _adapter: DateAdapter<any>) {
    const defaultLang = this._translateService.getDefaultLang();
    this.setLocale(defaultLang);
    this._translateService.onLangChange.subscribe(langObj => {
      this.setLocale(langObj.lang);
    });
  }
  setLocale(lang: string): void {
    lang === 'en' ? this._adapter.setLocale('en-GB') : this._adapter.setLocale('vi-VN');
  }
}
